import { useEffect, useState } from 'react'

/**
 * `value`, once it has stopped changing for `delayMs`. What a search-as-you-type
 * field queries with: one request per pause instead of one per keystroke against
 * the rate-limited API.
 */
export const useDebouncedValue = <T,>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
